export const RISK_PROFILES_LIST_APP_STATE_SLICE_KEY = 'riskProfilesList';
const RISK_PROFILES_LIST_STATE_KEYS = [
    'owner',
    'page',
    'sortColumn',
    'sortDirection',
    'name',
    'viewRootFolder',
    'includeEmptyFolders',
];
export { RISK_PROFILES_LIST_STATE_KEYS };
// The system default state excludes sortColumn and sortDirection
export const RISK_PROFILES_LIST_SYSTEM_DEFAULT_STATE = {
    owner: {
        me: true,
        shared_with_me: true,
        public: true,
    },
    name: '',
    page: 1,
    viewRootFolder: null,
    includeEmptyFolders: false,
};
